import { useCallback, useContext, useRef } from 'react';
import { AppContext } from '../App';
import { getCurrentLab } from '../clients/lab_client';
import { logError, logInfo } from '../config_and_helpers/logger';

const LOG_CONTEXT = 'useRefreshCurrentLab';

/**
 * Re-fetch GET /labs/current/ (e.g. when presigned logo_url expires).
 *
 * @returns {() => Promise<void>}
 */
export function useRefreshCurrentLab() {
  const { token, setCurrentLab } = useContext(AppContext);
  const inFlightRef = useRef(false);

  return useCallback(async () => {
    if (!token || inFlightRef.current) {
      return;
    }
    inFlightRef.current = true;
    const result = await getCurrentLab(token);
    inFlightRef.current = false;
    if (result.success) {
      setCurrentLab(result.data);
      logInfo(LOG_CONTEXT, 'currentLab refreshed', { labId: result.data?.id });
    } else {
      logError(LOG_CONTEXT, 'refresh currentLab failed', {
        status: result.status ?? null,
        messages: result.messages,
      });
    }
  }, [token, setCurrentLab]);
}
